import { productColors } from '@givebutter/util';
import { GoalbarIndicator } from 'components/goalbar/goalbar-indicator';
import styled, { css } from 'styled-components';

interface StyledGoalbarProps {
    percentage?: number;
}

const computeGoalBarPercent = ({ percentage = 0 }: StyledGoalbarProps) => {
    return 100 - percentage;
};

const Wrapper = styled.div<StyledGoalbarProps>`
    height: 2rem;
    padding: 0.25rem;
    position: relative;
    border-radius: 25rem;
    background-color: #f4f4f4;
    z-index: 1;

    & ${GoalbarIndicator}, &:after {
        position: absolute;
        bottom: 0;
    }

    & ${GoalbarIndicator} {
        top: 0;
        z-index: 3;
        ${props => {
            const { percentage = 0 } = props;
            const computedPercent = computeGoalBarPercent({ percentage }) - 0.5;
            if (percentage === 0) {
                return css`
                    left: 0;
                    align-items: start;
                `;
            }

            return css`
                right: ${computedPercent}%;
                align-items: flex-end;
            `;
        }}
    }

    &:after {
        top: 0.26rem;
        left: 0.286rem;
        right: ${computeGoalBarPercent}%;
        content: '';
        height: 1.5rem;
        width: inherit;
        border-radius: inherit;
        z-index: 1;
        background: linear-gradient(
            228.31deg,
            ${productColors.warning[300]} 47.62%,
            ${productColors.warning[400]} 76.18%
        );
    }
`;

export { Wrapper };
